// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}

.review__header {
  flex: 0 0 auto;
  z-index: 10;
  background: var(--palette-bg);
  box-shadow: 0 3px 8px rgba(28, 27, 26, 0.06);
}
.review__top {
  padding: 0 var(--pad) 12px;
}
.review__sum {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}
.review__date {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.05;
  margin-top: 2px;
}
.review__score {
  text-align: right;
}
.review__total {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 2rem;
  color: var(--palette-primary);
  line-height: 1;
}
.review__hint {
  text-align: center;
  font-size: 0.72rem;
  color: var(--palette-text-muted);
  margin-top: 10px;
}

.review__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 24px);
}

.review__scorecard {
  margin-top: 16px;
}
.scorecard__cells {
  display: flex;
  align-items: stretch;
  gap: 10px;
}
.scorecell {
  flex: 1;
  background: var(--palette-surface);
  border: 1px solid var(--palette-border);
  border-radius: 12px;
  padding: 12px 10px;
  text-align: center;
}
.scorecell--total {
  border-color: var(--palette-primary);
}
.scorecell__val {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1;
  color: var(--palette-text);
  font-variant-numeric: tabular-nums;
}
.scorecell--total .scorecell__val {
  color: var(--palette-primary);
}
.scorecell__unknown {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--palette-text-muted);
  letter-spacing: 0.06em;
}
.scorecell__lbl {
  font-size: 0.66rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
  margin-top: 6px;
}
.infoBtn {
  display: inline-flex;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--palette-primary);
  cursor: pointer;
}
.infoBtn svg {
  width: 16px;
  height: 16px;
  display: block;
}
.review__return {
  margin-top: 12px;
  padding: 12px 14px;
  background: var(--palette-surface);
  border: 1px solid var(--palette-border);
  border-radius: 12px;
  font-size: 0.86rem;
  line-height: 1.4;
  color: var(--palette-text-muted);
}
.review__return b {
  color: var(--palette-text);
}

.rarityInfo__scrim {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(28, 27, 26, 0.45);
}
.rarityInfo__card {
  width: 100%;
  max-width: 360px;
  background: var(--palette-bg);
  border-radius: 16px;
  padding: 22px;
  box-shadow: 0 12px 40px rgba(28, 27, 26, 0.25);
}
.rarityInfo__title {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.25rem;
  margin-bottom: 10px;
}
.rarityInfo__body {
  font-size: 0.92rem;
  line-height: 1.5;
  color: var(--palette-text-muted);
  margin: 0 0 18px;
}

.review__medals {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin: 14px 0 6px;
}
.mchip {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.4em 0.88em;
  border-radius: 999px;
  background: var(--palette-surface);
  border: 1px solid var(--palette-border);
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--palette-text);
}
.mdot {
  width: 0.72em;
  height: 0.72em;
  border-radius: 50%;
}
.mdot.a {
  background: var(--palette-primary);
}
.mdot.g {
  background: var(--medal-gold);
}
.mdot.s {
  background: var(--medal-silver);
}
.mdot.b {
  background: var(--medal-bronze);
}

/* Section headers used by ReviewRareWords / ReviewAllWords */
.majorSectionHeader {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.15rem;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--palette-border);
  margin: 24px 0 12px;
}
.majorSectionSubHeader {
  font-size: 0.78rem;
  color: var(--palette-text-muted);
  margin: -6px 0 12px;
}
.majorSectionContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rareHeader,
.regularHeader {
  font-size: 0.66rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
  margin-top: 8px;
}
.rareHeader.gold {
  color: #8a6f10;
}
.sectionContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 0.44em;
  margin-bottom: 8px;
}

.review__community {
  margin-top: 22px;
  text-align: center;
}
.review__community b {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.4rem;
  font-variant-numeric: tabular-nums;
}
.review__community-sub {
  font-size: 0.82rem;
}
`, "",{"version":3,"sources":["webpack://./src/screens/reviewPuzzleScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,4CAA4C;AAC9C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,OAAO;EACP,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA,6DAA6D;AAC7D;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".review {\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n}\n\n.review__header {\n  flex: 0 0 auto;\n  z-index: 10;\n  background: var(--palette-bg);\n  box-shadow: 0 3px 8px rgba(28, 27, 26, 0.06);\n}\n.review__top {\n  padding: 0 var(--pad) 12px;\n}\n.review__sum {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n}\n.review__date {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.25rem;\n  line-height: 1.05;\n  margin-top: 2px;\n}\n.review__score {\n  text-align: right;\n}\n.review__total {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 2rem;\n  color: var(--palette-primary);\n  line-height: 1;\n}\n.review__hint {\n  text-align: center;\n  font-size: 0.72rem;\n  color: var(--palette-text-muted);\n  margin-top: 10px;\n}\n\n.review__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 24px);\n}\n\n.review__scorecard {\n  margin-top: 16px;\n}\n.scorecard__cells {\n  display: flex;\n  align-items: stretch;\n  gap: 10px;\n}\n.scorecell {\n  flex: 1;\n  background: var(--palette-surface);\n  border: 1px solid var(--palette-border);\n  border-radius: 12px;\n  padding: 12px 10px;\n  text-align: center;\n}\n.scorecell--total {\n  border-color: var(--palette-primary);\n}\n.scorecell__val {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 1.5rem;\n  line-height: 1;\n  color: var(--palette-text);\n  font-variant-numeric: tabular-nums;\n}\n.scorecell--total .scorecell__val {\n  color: var(--palette-primary);\n}\n.scorecell__unknown {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  color: var(--palette-text-muted);\n  letter-spacing: 0.06em;\n}\n.scorecell__lbl {\n  font-size: 0.66rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n  margin-top: 6px;\n}\n.infoBtn {\n  display: inline-flex;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--palette-primary);\n  cursor: pointer;\n}\n.infoBtn svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n.review__return {\n  margin-top: 12px;\n  padding: 12px 14px;\n  background: var(--palette-surface);\n  border: 1px solid var(--palette-border);\n  border-radius: 12px;\n  font-size: 0.86rem;\n  line-height: 1.4;\n  color: var(--palette-text-muted);\n}\n.review__return b {\n  color: var(--palette-text);\n}\n\n.rarityInfo__scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(28, 27, 26, 0.45);\n}\n.rarityInfo__card {\n  width: 100%;\n  max-width: 360px;\n  background: var(--palette-bg);\n  border-radius: 16px;\n  padding: 22px;\n  box-shadow: 0 12px 40px rgba(28, 27, 26, 0.25);\n}\n.rarityInfo__title {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 1.25rem;\n  margin-bottom: 10px;\n}\n.rarityInfo__body {\n  font-size: 0.92rem;\n  line-height: 1.5;\n  color: var(--palette-text-muted);\n  margin: 0 0 18px;\n}\n\n.review__medals {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  margin: 14px 0 6px;\n}\n.mchip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5em;\n  padding: 0.4em 0.88em;\n  border-radius: 999px;\n  background: var(--palette-surface);\n  border: 1px solid var(--palette-border);\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--palette-text);\n}\n.mdot {\n  width: 0.72em;\n  height: 0.72em;\n  border-radius: 50%;\n}\n.mdot.a {\n  background: var(--palette-primary);\n}\n.mdot.g {\n  background: var(--medal-gold);\n}\n.mdot.s {\n  background: var(--medal-silver);\n}\n.mdot.b {\n  background: var(--medal-bronze);\n}\n\n/* Section headers used by ReviewRareWords / ReviewAllWords */\n.majorSectionHeader {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.15rem;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--palette-border);\n  margin: 24px 0 12px;\n}\n.majorSectionSubHeader {\n  font-size: 0.78rem;\n  color: var(--palette-text-muted);\n  margin: -6px 0 12px;\n}\n.majorSectionContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.rareHeader,\n.regularHeader {\n  font-size: 0.66rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n  margin-top: 8px;\n}\n.rareHeader.gold {\n  color: #8a6f10;\n}\n.sectionContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.44em;\n  margin-bottom: 8px;\n}\n\n.review__community {\n  margin-top: 22px;\n  text-align: center;\n}\n.review__community b {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.4rem;\n  font-variant-numeric: tabular-nums;\n}\n.review__community-sub {\n  font-size: 0.82rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
